'use strict';

import dayjs from 'dayjs';
import { findLast, get } from 'lodash';

export { default as removeAccents } from 'remove-accents';


/// Strings

export function isEmail(str) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(str);
}

export function isPhone(str) {
    return /^[0-9 ()+-]+$/.test(str);
}

export function ucfirst(str) {
    return `${str.charAt(0).toUpperCase()}${str.substr(1)}`;
}


/// Collections

export function mapFind(coll, fn) {
    for (const x of coll) {
        const y = fn(x);
        if (y)
            return y;
    }
}

export function count(coll, pred) {
    let acc = 0;
    for (const x of coll) {
        if (pred(x))
            acc += 1;
    }
    return acc;
}

export function asKeys(array, valueOrFn) {
    const isFn = (typeof valueOrFn === 'function');

    return array.reduce((o, f) => o[f] = isFn ? valueOrFn(f) : valueOrFn, {});
}

export function setAll(obj, value) {
    for (const k in obj) {
        obj[k] = value;
    }
}


/// Promises

export function delay(millis) {
    return new Promise(resolve => {
        setTimeout(resolve, millis);
    });
}

export function defer() {
    let res, rej;

    const promise = new Promise((resolve, reject) => {
        res = resolve;
        rej = reject;
    });

    promise.resolve = res;
    promise.reject = rej;

    return promise;
}

export function promisify(fn, ...args) {
    return new Promise((resolve, reject) => {
        fn(...args, (err, result) => {
            if (err) {
                reject(err);
            } else {
                resolve(result);
            }
        });
    });
}


/// Data access

export function findById(items, id) {
    return (!items || !id) ? null : items.find(i => i.id === id);
}

export function getCaseLengthInDays(from, to) {
    return Math.ceil(dayjs(to).diff(dayjs(from), 'day', true));
}

export function getCaseLengthInMonths(from, to) {
    const days = getCaseLengthInDays(from, to);

    return dayjs(from).add(days, 'days').diff(dayjs(from), 'month', true);
}

export function getLatestSnapped(case_, fieldPath) {
    const snapshot = findLast(case_.amendments, a => a.signed)?.snapshot ?? case_.contract.snapshot;

    return get(snapshot, fieldPath);
}


/// Axios

// Enable JSON response on error for calls with blob or arraybuffer response on success
export function ensureJsonErrors(axiosInstance) {
    axiosInstance.interceptors.response.use(
        response => { return response; },
        err => {
            if (err.request?.responseType === 'blob' &&
                err.response?.data instanceof Blob &&
                err.response.data.type &&
                err.response.data.type.toLowerCase().indexOf('json') !== -1) {

                return new Promise((resolve, reject) => {
                    let reader = new FileReader();

                    reader.onload = () => {
                        err.response.data = JSON.parse(reader.result);

                        resolve(Promise.reject(err));
                    };

                    reader.onerror = () => {
                        reject(err);
                    };

                    reader.readAsText(err.response.data);
                });
            }

            if (err.config?.responseType === 'arraybuffer' && err.response) {
                return new Promise(resolve => {
                    err.response.data = JSON.parse(err.response.data.toString());

                    resolve(Promise.reject(err));
                });
            }

            return Promise.reject(err);
        },
    );

    return axiosInstance;
}
